import {PIXI} from '@colonist/pixi'
import {uiGameManager} from '../../EntryShared'
import {StorageWrapper} from '../../StorageWrapper'
import {UIGameAnimation} from '../../ui_game/UIGameEventController'

export abstract class UIGameAnimationBase implements UIGameAnimation {
    private onStopCallback?: () => void
    protected readonly abstract forceEnableAnimation: boolean

    protected viewToAnimate: PIXI.Container

    protected _isAnimationInProgress = false
    get isAnimationInProgress() {
        return this._isAnimationInProgress
    }

    abstract onGameTick(deltaTime: number, elapsedMS: number): void

    start() {
        this._isAnimationInProgress = true
        uiGameManager.eventController.registerUIGameAnimation(this)
        if(this.areAnimationsDisabled()) this.stop()
        return this
    }

    stop(ignoreCallback: boolean = false) {
        if(!this._isAnimationInProgress) return
        this._isAnimationInProgress = false
        uiGameManager.eventController.unregisterUIGameAnimation(this)
        if(!ignoreCallback) this.onStopCallback?.()
        this.resetToDefaultState()
    }

    setOnStopCallback(onStopCallback: () => void) {
        this.onStopCallback = onStopCallback
    }

    areAnimationsDisabled(): boolean {
        if(this.forceEnableAnimation) return false
        if(StorageWrapper.getAnimation() == true) return false
        return true
    }

    abstract resetToDefaultState(): void

    static composeAnimations(animations: UIGameAnimationBase[], delayBetweenAnimations: number): UIGameAnimationBase {
        for(let i = 0; i < animations.length - 1; i++) {
            const currentAnimation = animations[i]
            const nextAnimation = animations[i + 1]

            currentAnimation.setOnStopCallback(() => {
                setTimeout(() => {
                    nextAnimation.start()
                }, delayBetweenAnimations)
            })
        }
        return animations[0]
    }
}

